export const hasParentWithClass = (element: Element, parentClass: string): boolean => {
    const parent = element.parentElement;
    if (parent != null) {
        return parent.classList.contains(parentClass) ? true : hasParentWithClass(parent, parentClass);
    }
    return false;
};
